exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.forget-password[data-v-1f2bae3e] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  /* background: url(\"../assets/images/bg4.png\") no-repeat; */\n  background-size: cover;\n  top: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n#content[data-v-1f2bae3e] {\n  width: 400px;\n  height: 200px;\n  margin: 100px auto;\n  /* background: #d7e695; */\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  border-radius: 6px;\n}\n", ""]);

// exports
